module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-settings",
    class: {
      hidden: !_vm.expanded
    }
  }, [_c('a', {
    staticClass: "hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_vm._v(_vm._s(_vm.expanded ? "hide" : "show"))]), _vm._v(" "), _c('h5', [_vm._v("Layout Settings")]), _vm._v(" "), _c('select', {
    on: {
      "change": _vm.changeLayout
    }
  }, [_c('option', {
    attrs: {
      "value": "ngraph",
      "selected": ""
    }
  }, [_vm._v("NGraph")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "d3force"
    }
  }, [_vm._v("D3 Force")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Steps count")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.steps),
      expression: "settings.steps"
    }],
    domProps: {
      "value": (_vm.settings.steps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.settings.steps = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isNGraph) ? _c('NLayoutSettings', {
    attrs: {
      "settings": _vm.settings
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isNGraph) ? _c('D3LayoutSettings', {
    attrs: {
      "settings": _vm.settings
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.restartLayout()
      }
    }
  }, [_vm._v("Restart Layout")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.detectClusters()
      }
    }
  }, [_vm._v("Detect clusters")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26c61af8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GraphSettings.vue
// module id = 238
// module chunks = 1